module.exports = __webpack_public_path__ + "img/img3.6cf42ff0.svg";